export const index = {
  // 簡體文中
  head: {
    cart: "購物車",
    list: "清單",
    msg: "信息",
    mine: "個人",
    login: "登入",
    register: "註冊"
  },
  foot: {
    shop: "商城",
    about: "關於我們",
    news: "新聞中心",
    cooperation: "加盟合作",
    contact: "聯絡我們",
    privacy: "私隱政策說明",
    conditions: "一般性條款和細則",
    questions: "常見問題"
  },
  address:{
    surname: "姓",
		name: "名",
		inputName2:"請輸入收貨人名字",
		inputSurname:"請輸入收貨人姓氏",
		address1: "地址1",
		address2: "地址2(選填)",
		inputAddress2:"請輸入街道名稱和編號",
		inputAddress3:"請輸入樓宇編號/名稱/街道名稱",
		inputAddress4:"街道/道路名稱/轄區",
		postCode: "郵政編碼",
		inputPostCode: "請輸入郵政編碼",
    notAddress:"您還沒有設置默認送貨地址，請添加後繼續結算",
    addressee:"收件人",
    title:"稱呼",
    mr: '先生',
    ms: '女士',
    phoneNumber:"聯系方式",
    detailedAddress:"詳細地址",
    next:"下一步",
    shippingAddress:"送貨地址",
    addAddress:"新增地址",
    defaultAddress:"默認地址",
    edit:"編輯",
    delete:"刪除",
    setDefaultSuccess:"設置默認成功",
    pleaseRecipient:"請輸入收件人",
    pleaseRecipient20: "收件人姓名請設置在20位內",
    pleaseContact :"請輸入聯系方式",
    pleaseArea: "請選擇正確的地址",
    regionSelectionProvince:"地區選擇省",
    regionSelectionCity:"地區選擇市",
    regionSelectionArea:"地區選擇區",
    pleaseDetailAddress:"請輸入詳細地址",
    pleaseCode:"請輸入郵編",
    pleaseCodeTip:"請輸入郵編(請填寫0000)",
    code:"郵編",
    editSuccess:"修改成功",
    addSuccess:"添加成功",
  },
  account:{
    info:"賬戶信息",
    setOldPassword:"舊密碼",
    setPassword: "設定密碼 *(請輸入6-10單元，包含字母、數字)",
    setNewPassword:"設定新密碼",
    changePassword:"修改密碼",
    setNickname:"設置昵稱",
    pleaseNickname:"請輸入昵稱",
    pleasePassword:"請輸入新密碼",
    nickname:"昵稱",
    setAvatar:"設置頭像",
    avatar:"頭像",
    ok:"確定",
    setAvatarSuccess:"設置頭像成功",
    editNicknameSuccess:"修改昵稱",
    setNicknameSuccess:"修改昵稱成功",
    pleasePasswordSuccess:"新密碼設置成功",
    sureExit:"確定退出嗎?",
    tips:"提示",
    exit:"退出成功!",
  },
  login: {
    emailAddress:"電郵地址*",
    emailAddressNot:"電郵地址",
		guestLog: "免登入購物",
    youxing:"郵箱",
    code:"驗證碼",
    ResendSeconds:"秒後重發",
    getCode:"獲取驗證碼",
    password:"密碼",
    pleaseEmail:"請輸入郵箱",
    pleaseCode:"請輸入驗證碼",
    pleasePassword:"請輸入密碼",
    editSuccess:"修改成功",
    sendSuccess:"發送成功",
    PleaseMobileNumberAddress:"請輸入手機號碼/電郵地址",
    pleaseLastName:"請輸入姓氏",
    LastName50: "請輸入小於50個字符的姓氏",
    name50: "請輸入小於50個字符的名字",
    pwd20: "請輸入小於20個字符的密碼",
    pleaseName:"請輸入名字",
    pleasePhoneNumber:"請輸入手機號碼",
    pleaseEmailAddress:"請輸入電郵地址",
    pleaseRightEmailAddress:"請輸入正確電郵地址",
    title: "歡迎來到軒琴居牌床褥",
    phone: "手機號碼/電郵地址",
    login: "登入",
    pass: "登入密碼",
    account: "未有賬戶？",
    now: "立即登記",
    forget: "忘記密碼",
    register: "註冊新賬戶",
    success: "完成",
    surname: "姓氏 * ",
    name: "名字 * ",
    tel: "手機號碼 *",
    setPassword: "設定密碼 *(請輸入6-10單元，包含字母、數字)",
    email: "電郵地址（可選）",
    agree: "我已閱讀並同意",
    policy: "《用戶註冊協議及私隱政策》",
    tickAgree: "請勾選協議"
  },
  tab: {
    page: "商城首頁",
    classification: "商城分類",
    center: "新聞中心",
    cooperation: "加盟合作",
    about: "關於我們",
    contact: "聯絡我們"
  },
  pageSubtitle: {
    t1: "為你推薦",
    t2: "今日熱賣",
    t3: "更多熱門推薦",
    t4: "感謝祭震撼優惠價",
    t5:"感謝祭震撼優惠價"
  },
  contact: {
    title: "聯絡我們",
    store: "門店地址",
    city: "門店地區",
    type: "門店類型",
    county: "門店地域",
    plaCounty: "請選擇門店所在地域",
    plaCity: '請選擇門店所在地區',
    plaType: '請選擇門店類型',
    self: '自營門店',
    franchise: '加盟店',
    null: "暫無門店信息",
    tips: "敬請咨詢，我們將竭誠為您服務！",
    words: "在線留言",
    weChat: 'AI在線客服',
    clickWords: "點擊頁面進入留言",
    telSubtitle: "點擊聯繫客服 WhatsApp",
    telWhatsApp: "客服 WhatsApp",
    telTitle: "服務電話：",
    telNumber: "400 888 888",
    service: "人工服務時間：",
    serviceTimer: "工作日9:00~18:00",
    emailTitle: "電子郵件",
    email: "郵箱：",
    emailNumber: "XXXXX@XXX.XXX",
    emailTips: "請隨時給我們發送電子郵件，我們會及時給您答復",
    submit: "保存提交",
    clickWeChat: "點擊聯繫AI客服"
    // userName:"請輸入您的姓名",
    // telephone:"請輸入聯繫電話",
    // telephoneRight:"請輸入正確聯繫電話",
    // email:"請輸入電郵地址",
    // emailRight:"請輸入正確電郵地址",
    // content:"請輸入您留言的內容",
    // success:"提交成功"
  },
  about: {
    title: "關於我們",
    tab1: "公司介紹",
    tab2: "發展歷程",
    tab3: "榮獲殊榮",
  },
  apply: {
    title: "申請加盟",
    name: "姓 名",
    inputName: "請輸入您的姓名",
    tel: "電 話",
    telephone:"請輸入聯繫電話",
    telephoneRight:"請輸入正確聯繫電話",
    inputTel: "請輸入聯繫電話",
    email: "電 郵",
    inputEmail: "請輸入電郵地址",
    emailRight:"請輸入正確電郵地址",
    area: "地 區",
    success:"提交成功",
    applySuccess:"申請成功",
    inputArea: "請輸入申請加盟地區",
    submit: "提交申請",
    textarea: "請輸入您留言的內容"
  },
  news: {
    title: "新聞中心",
    read: "閱讀全文",
    temArticleTitle: "試睡活動規則",
    news: "企業新聞",
    media: "媒體報到",
    HKpromotion: "中國香港促銷",
    promotion: "中國促銷",
    overseas: "海外促銷",
  },
  classify: {
    null: "暫無分類",
    bedding: "床褥",
    hair: "梳發",
    furniture: "傢私",
    pillow: "枕頭",
    custom: "訂造傢私",
    projects: "特別項目",
    article: "床上用品",
    hot: "熱賣商品"
  },
  info: {
    account: "我的賬戶",
    settings: "一般設定",
    seek: "尋求協助",
    more: "更多信息",
    orderRecord: "訂單記錄",
    guestOrder: "遊客訂單",
    refund: "退款退貨",
    coupon: "電子優惠券",
    information: "賬戶資料",
    address: "送貨地址",
    review: "商品評論",
    notice: "優惠資訊通知",
    language: "語言切換",
    novice: "新手攻略",
    vip: "VIP會員計劃",
    problem: "常見問題",
    promotion: "招商加盟",
    contact: "聯絡我們",
    privacy: "私隱政策說明",
    conditions: "一般性條款及細則"
  },
  message: {
    read:"已讀",
    system: "系統訊息",
    notification: "訊息通知",
    reminder: "發貨提醒",
    payment: "付款成功",
    refund: "退款退貨",
    customer: "客服訊息",
    unread: "未讀",
    sendGoods: "發貨提醒",
    issued: "您的訂單已出庫",
    detail: "訊息詳情",
    msgLoading: '驗證碼正在發送',
    click: '請勿重複點擊'
  },
  cart: {
    market: '市場價',
    shopping: "購物車",
    subtotal: "商品小計",
		conflict: "因所選商品配送時段衝突，請分單購買",
    promotional: "促銷優惠",
    express: "運費合計",
    total: "購物車合計",
    immediate: "立即結算",
    color: "顏       色:",
    price: "單       價:",
    number: "數       量:",
    selectAll: "全選",
    noGoodsShoppingCart: "購物車沒有貨品，即前往選擇鐘意商品",
    go: "前往選購"
  },
  del: {
    tips: "確認要刪除嗎？",
    ok: "確定",
    remind:"提醒",
    cancel: "取消",
    delSuccess:"刪除成功",
    pleaseSelect:"請選擇商品",
    affirm:"確認收貨嗎？",
    receivedSuccess:"收貨成功",
  },
  goods:{
    refund:"退貨退款",
    orderTime:"下單時間:",
    orderNo:"下單編號: ",
    remainingTime:"剩餘支付時間",
    size:"尺寸規格:",
    common: "共",
    piece: "件",
    refunding:"退款中",
    color: "顏    色:",
    refundDetails:"退款詳情",
    go: "前往選購",
    noOrder: "暫無訂單信息",
    orderNumber:"訂單編號",
    refundCode:"退款編碼",
    refundReason:"退款原因",
    cargoDamage:"貨物損壞",
    refundAmount:"退款金額",
    applicationStatus:"申請狀態",
    waitingApplication:"等待申請",
    special: "特價",
    sold: "已售",
    best: "熱銷貨品",
    size: "尺寸規格",
    color: "貨品顏色",
    number: "數       量",
    add: "加入購物車",
    list: "加入我的清單",
    special: "特殊訂造",
    detail: "詳細介紹",
    review: "商品評論"
  },
  order: {
    order: "個人訂單",
    all: "全部",
    pending: "待付款",
    shipped: "待發貨",
    received: "待收貨",
    commented: "待評論",
    time: "下單時間:",
    no: "下單編號:",
    writeComments: "寫評論",
    cancellation: "取消訂單",
    common: "共",
    piece: "件",
    color: "顏    色:",
    paymentTime: "剩余支付時間",
    size: "尺寸規格:",
    go: "前往選購",
    noOrder: "暫無訂單信息",
    score: "產品評分",
    sayScore: "請說說使用評價吧！",
    confirmReceipt:"確認收貨",
    continuePay:"繼續支付",
    deleteOrder:"刪除訂單",
    refundOnly :"僅退款",
    refundTips:"沒有收到貨，貨與賣家協商同意不用退貨僅退款",
    returnRefund:"退貨退款",
    goodsReturned:"已收到貨，需要退換貨物",
    cargoStatus:"貨物狀態",
    pleaseSelect:"請選擇",
    refundReason:"退款原因",
    refundAmount:"退款金額",
    numberApplications:"申請件數",
    replenish:"補充原因和憑證",
    pleaseRefundReason:"請輸入退款原因",
    saveSubmit:"保存提交",
    pleaseSelectCargoStatus:"請選擇貨物狀態",
    PleaseSelectRefundReason:"請選擇退款原因",
    refundReturnOption:"退款退貨選擇",
    commentSuccess:"評論成功",
    cancelSuccee:"取消退款成功",
    sureCancelRefund:"確認取消退款嗎？",
    sureDeleteOrder:"確認刪除訂單嗎？",
    sureCancelOrder:"確認取消訂單嗎？",
    CancelSuccess:"取消成功"
  },
  orderDetail: {
    orderReceived: "訂單待收貨",
    size: "尺寸規格:",
    color: "顏       色:",
    price: "單       價:",
    number: "數       量:",
    receiptInfo: "收貨信息",
    consignee: "收貨人:",
    contactNumber: "聯繫電話：",
    shippingAddress: "收貨地址：",
    orderNo: "訂單編號:",
    orderTime: "下單時間:",
    subtotalGoods: "商品小計",
    promotional: "促銷優惠",
    confirm: "確認收貨",
  },
  orderStatusTxt:{
    cancel: "已取消",
    pay: "待支付",
    sendGoods: "待發貨",
    received: "待收貨",
    evaluated: "待評價",
    completed: "已完成",
    refunded: "已退款",
    refundFailed: "退款失敗",
    cancel: "已取消",
    cancel: "已取消",
  },
  statusTxt:{
    cancel: "已取消",
    refundProcessing: "退款處理中",
    refundProcessing: "退款處理中",
    refunded: "已退款",
    refundRejected: "退款已拒絕",
  },
  goodsDeatil:{
    overview:"商品簡介：",
    specialPrice:"特價",
    length:"長度",
    PleaseLength:"請輸入內容長度",
    width:"寬度",
    pleaseWidth:"請輸入內容寬度",
    height:"高度",
    price:"價格：",
    lengthMust:"長度必須大於0",
    widthMust:"寬度必須大於0",
    addListSuccess:"成功加入我的清單!",
    addshoppingSuccess:"成功加入購物車!",
    sold:"已售",
    dimensions:"尺寸規格",
    itemColor:"貨品顏色",
    number:"數量",
    addCart:"加入購物車",
    buyNow: "立即購買",
    addList:"加入我的清單",
    info:"詳細介紹：",
    userReviews:"商品評論",
    allUserReviews:"全部商品評論",
    comments:"則評論",
    writeComments:"寫評論",
    hotGoods:"熱銷貨品",
    specialOrder:"特殊訂造",
    pleaseSelect:"請選擇",
    size:"尺碼",
    unit:"（單位：英呎）",
    height:"高度",
    color:"顏色",
    score: "產品評分",
    delivery: '送貨/退貨',
    sayScore: "請說說使用評價吧！"
  },
  goodsConfirmOrder:{
    title: "送貨信息",
    addressee:"收件人",
    replace:"更換送貨信息",
    color: "顏       色:",
    receiptInfo: "收貨信息",
    consignee: "收貨人:",
    dimensions:"尺寸規格",
    shippingAddress: "收貨地址：",
    goodsList:"商品清單",
    deliveryTime:"送貨時間",
    deliveryTimePlease:"請選擇送貨時間",
    deliveryTimePlease2:"已選擇送貨時間",
    notUseTime:"沒有可選時間",
    deliveryTimeTips:"部分商品我們將與您聯繫溝通送貨時間",
    useTimeRange:"可選日期",
    useTimeRange2:"可選時間",
    orderDetail:"訂單明細",
    subtotalGoods: "商品小計",
    promotional: "促銷優惠",
    expenses:"配送費用",
    total:"購物車合計",
    submit :"提交訂單",
  },
  payment:{
    wxPay: "請使用微信掃碼支付",
    wxPaySuccess: "支付成功",
    wxPayCancel: "取消支付",
    cashier:"收銀臺",
    success:"訂單提交成功，請盡快付款",
    orderNo:"訂單編號：",
    amount:"待付金額：",
    tips1:"請您在",
    tips2:"內完成支付，否則訂單會被自動關閉",
    paymentMethod:"支付方式",
    more :"更多支付方式",
    next :"下一步",
    min: '分',
    sec: '秒'
  },
  coupon:{
    heima:"香港軒琴居牌",
    coupons:"電子優惠券",
    notUsed:"未使用",
    used:"已使用",
    expired:"已過期",
    toUse:"去使用",
    full:"滿",
    rebate:"回贈",
    couponMethod:"領取優惠券",
    noCoupon:"暫無優惠券",
    drawSuccess:"領取成功",
    draw:"已領取",
    receive:"領取",
    ranout:"已搶光",
  },
}



//////////////////
// WEBPACK FOOTER
// ./common/lang/tc.js
// module id = lQyn
// module chunks = 29